import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'uiv/src/locale/lang/en-US'

Vue.use(VueI18n)

const messages = {
   lang: {},
}
Object.assign(messages.lang, locale)

if ((window as any).translations) {
   Object.assign(messages.lang, (window as any).translations)
}

const i18n = new VueI18n({
   locale: 'lang', // set fallback locale
   fallbackLocale: 'lang', // set fallback locale
   messages, // set locale messages
})

export default i18n
